import { PostMessageRepository } from './PostMessageRepository';

export class PostMessageReceiver{
  private readonly sourceWindow: Window;
  private readonly targetOrigin: string;
  private messageListener: (event: MessageEvent) => void;
  private postMessageRepository: PostMessageRepository;

  constructor(sourceWindow: Window, targetOrigin: string, postMessageRepository: PostMessageRepository) {
    this.sourceWindow = sourceWindow;
    this.targetOrigin = targetOrigin;
    this.postMessageRepository = postMessageRepository;
    this.messageListener = this.handleMessage.bind(this);
  }

  public initialize(): void {
    this.sourceWindow.addEventListener('message', this.messageListener);
  }

  private handleMessage(event: MessageEvent): void {
    const data = event.data as unknown;
    const origin = event.origin;

    const targets = this.postMessageRepository.getResponseIdentifiers();
    if (this.targetOrigin === "*" || origin === this.targetOrigin) {
      if (typeof data === 'object' && data !== null) {
        const matchingTarget = targets.find(target => target in data);
        if (matchingTarget) {
          const postMessageRequest = this.postMessageRepository.getPostMessageRequest(matchingTarget);
          if (postMessageRequest) {
            this.postMessageRepository.setPostMessageRequestStatus(matchingTarget, 'COMPLETED');
            postMessageRequest.callback(event);
          }
        }
      } 
    }
  }
}
